import { useContext } from 'react';

import { SearchFilterContext } from '@app/features/addressBook/components/AddressBookSearchFilterProvider';

export default function useSearchFilterContext() {
  return useContext(SearchFilterContext);
}
